import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Button,
  Spin,
  Col,
  Modal,
  Row,
  message,
} from 'antd';
import { onError } from 'utils/handlers';
import { contribuyenteToString } from 'utils/padronesToString';
import FormSubmitControls from 'components/FormSubmitControls';
import Table from 'components/Table';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import {
  deleteContribuyenteVinculado,
  getContribuyentesVinculados,
  patchContribuyenteVinculado,
  postContribuyenteVinculado,
} from 'api/empresas/contribuyenteVinculado';
import { getTiposDeContribuyente } from 'api/empresas';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { InputSearchPro } from 'components/InputSearch';
import { getContribuyenteCaja } from 'api/empresas/contribuyentes';

export const model = 'contribuyentevinculado';
export const catalogsModels = ['obligacionfiscal', 'contribuyente', 'tipodecontribuyentevinculado'];

export const permissionContribuyentesVinculados = {
  title: 'Contribuyentes Vinculados',
  model,
  catalogs: catalogsModels,
};

const ContribuyentesVinculados = ({
  contribuyente,
  permission,
  callback,
  fetchCallback,
  mutable,
}) => {
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [padronFound, setPadronFound] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [tiposDeContribuyentes, setTiposDeContribuyentes] = useState([]);
  const [visibleBusquedaPadrones, setVisibleBusquedaPadrones] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    // eslint-disable-next-line max-len
    const _data = await getContribuyentesVinculados({ contribuyente_principal: contribuyente });
    setData(_data);
    if (fetchCallback) fetchCallback(_data);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetch = async () => {
      setLoading(true);
      const _data = contribuyente
        ? await getContribuyentesVinculados({ contribuyente_principal: contribuyente }) : [];
      const _tiposDeContribuyentes = await getTiposDeContribuyente();
      if (mounted) {
        setData(_data);
        if (fetchCallback) fetchCallback(_data);
        setTiposDeContribuyentes(_tiposDeContribuyentes);
        setLoading(false);
      }
    };
    fetch();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    form.resetFields();
    setVisible(false);
    setSelectedRowKeys([]);
    setPadronFound();
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      values.contribuyente_principal = contribuyente;
      const saved = await (key
        ? patchContribuyenteVinculado(key, values)
        : postContribuyenteVinculado(values));
      if (saved) {
        if (callback) callback(saved);
        onCancel();
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue({
      ...record,
      contribuyente_vinculado: record.contribuyente_vinculado?.id,
    });
  };

  // const retrievePadron = async (id) => {
  //   const _padrones = await getContribuyenteCaja({ id });
  //   if (_padrones.length || _padrones.count) {
  //     if ((_padrones.length || _padrones.count) === 1) {
  //       const _padronFound = _padrones.results?.[0] || _padrones[0];
  //       if (_padronFound.id !== contribuyente) {
  //         setPadronFound(_padronFound);
  //         form.setFieldsValue({ contribuyente_vinculado: _padronFound.id });
  //       } else {
  //         message.warn('Un contribuyente no se puede vincular a si mismo.');
  //       }
  //     }
  //   }
  // };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const deleted = await deleteContribuyenteVinculado(key);
    if (deleted) {
      const match = data.find((e) => e.id === key);
      if (callback) callback({ message: `Contribuyente vinculado ${contribuyenteToString(match)} eliminado` });
      setVisibleAlert(false);
      onCancel();
      await fetchData();
    }
    setLoading(false);
  };

  const rowSelection = mutable ? {
    selectedRowKeys,
    type: 'radio',
  } : null;

  const columns = [
    {
      titleText: 'Contribuyente Vinculado',
      key: 'contribuyente_vinculado',
      dataIndex: 'contribuyente_vinculado',
      width: 300,
      render: (val) => contribuyenteToString(val),
    },
    {
      titleText: 'Tipo de Contribuyente',
      key: 'tipo_de_contribuyente_vinculado',
      dataIndex: 'tipo_de_contribuyente_vinculado',
      width: 300,
      render: (val) => tiposDeContribuyentes.find((e) => e.id === val)?.descripcion,
    },
  ];

  const resetAndValidate = () => {
    setPadronFound([]);
    form.resetFields(['q']);
    form.validateFields(['q']);
  };

  const searchPadron = async (_q) => {
    setLoading(true);
    const q = _q || form.getFieldValue('q');
    if (q) {
      const _padrones = await getContribuyenteCaja({ q });
      if (_padrones.length || _padrones.count) {
        if ((_padrones.length || _padrones.count) === 1) {
          const _padronFound = _padrones.results?.[0] || _padrones[0];
          setPadronFound(_padronFound);
          form.setFieldsValue({ contribuyente_vinculado: _padronFound.id });
        } else {
          message.warn('Ingrese una búsqueda más específica');
        }
      } else {
        message.warn('No se encontro el padrón');
      }
    }
    setLoading(false);
  };

  const rules = {
    required: [{ required: true }],
  };

  return (
    <>
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={mutable ? {
            onClickAdd,
            onClickDelete,
          } : null}
          allowSort={false}
          allowSearch={false}
          rowKey="id"
          permission={permission}
          hasAllViewPermission
          mobileColIndex={0}
        />
      </Spin>
      <Modal
        visible={visible}
        closable={false}
        footer={null}
        title={(
          <FormSubmitControls
            label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Contribuyente Vinculado`}
            onFinish={onFinish}
            onCancel={onCancel}
            loading={loading}
          />
        )}
        keyboard={!loading}
        maskClosable={!loading}
        onCancel={onCancel}
        forceRender
      >
        <Spin tip="Cargando..." spinning={loading}>
          <Col span={24}>
            <Form
              form={form}
              layout="vertical"
              onFinish={() => onFinish()}
            >
              <Row gutter={10}>
                <Col span={24}>
                  <InputSearchPro
                    label="Búsqueda Contribuyente"
                    name="q"
                    onClickAdvanced={() => setVisibleBusquedaPadrones(true)}
                    breakPoints={{
                      md: 24,
                    }}
                    inputProps={{
                      onPressEnter: () => searchPadron(),
                      onChange: ({ target: { value } }) => {
                        if (!value) {
                          resetAndValidate();
                        }
                      },
                    }}
                    resultProps={{
                      name: 'contribuyente_vinculado',
                      label: 'Contribuyente',
                      rules: rules.required,
                      dataSource: padronFound,
                      render: (padron) => contribuyenteToString(padron),
                      keyLabelRender: false,
                      onClear: resetAndValidate,
                      breakPoints: {
                        md: 24,
                      },
                    }}
                    disabled={!mutable}
                  />
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="tipo_de_contribuyente_vinculado"
                    label="Tipo de contribuyente"
                    rules={rules.required}
                  >
                    <Select dataSource={tiposDeContribuyentes} disabled={!mutable} allowClear />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Col>
        </Spin>
      </Modal>
      <ModalDelete
        onDelete={deleteItem}
        onCancel={() => {
          setVisibleAlert(false);
          setSelectedRowKeys([]);
        }}
        visible={visibleAlert}
        content=" el registro seleccionado?"
        loading={loading}
      />
      <BusquedaAvanzadaPadrones
        visible={visibleBusquedaPadrones}
        setVisible={setVisibleBusquedaPadrones}
        tipoDePadron={15}
        callback={(record) => {
          setPadronFound(record);
          form.setFieldsValue({
            contribuyente_vinculado: record.id,
          });
        }}
      />
    </>
  );
};

ContribuyentesVinculados.propTypes = {
  contribuyente: PropTypes.number,
  permission: PropTypes.shape({
    add: PropTypes.bool.isRequired,
    change: PropTypes.bool.isRequired,
    delete: PropTypes.bool.isRequired,
    export: PropTypes.bool.isRequired,
    import: PropTypes.bool.isRequired,
    view: PropTypes.bool.isRequired,
  }).isRequired,
  callback: PropTypes.func,
  fetchCallback: PropTypes.func,
  mutable: PropTypes.bool,
};

ContribuyentesVinculados.defaultProps = {
  contribuyente: null,
  callback: null,
  fetchCallback: null,
  mutable: true,
};

export default ContribuyentesVinculados;
